import { reactLocalStorage } from 'reactjs-localstorage';
import ReactGA from 'react-ga';
import { http } from '../../services/http';

const redirectToHomePage = () => {
  window.location.href = `${process.env.PUBLIC_URL}`;
};

export const getConfiguration = token => {
  ReactGA.event(
    {
      category: 'Shares',
      action: 'Exists configuration search',
      transport: 'beacon',
    },
    ['tracker1', 'tracker2'],
  );

  return dispatch => {
    return http
      .post(`/configure/read`, { token })
      .then(response => {
        if (response.data.result.status !== 404) {
          reactLocalStorage.set('token', response.data.result.token);
          reactLocalStorage.setObject('wardrobesConfigs', response.data.result.payload);
          reactLocalStorage.set('wardrobeHeight', response.data.result.payload[0].dimensions.y);
          dispatch({ type: 'GET_ARRANGEMENT_SUCCESS', data: response.data.result.payload });
          setTimeout(() => {
            window.location.href = `${process.env.PUBLIC_URL}/summary`;
          }, 0);
        } else {
          throw new Error('Configuration does not exist');
        }
        return response.data;
      })
      .catch(err => {
        dispatch({ type: 'GET_ARRANGEMENT_ERROR', data: err });
        if (err.response.status === 409) {
          reactLocalStorage.set('configurationHaveNotAvalibleItems', [
            err.response.data.result.products,
          ]);
        }
        redirectToHomePage();
      });
  };
};

export const saveConfiguration = (token, payload) => {
  const myToken = token ?? reactLocalStorage.get('token');
  return dispatch => {
    http.post(`/configure/save`, { token: myToken, payload }).catch(err => {
      dispatch({ type: 'GET_SAVE_CONFIGURATION_ERROR', data: err });
    });
  };
};

export const saveConfigurationNow = (token, payload) => {
  const myToken = token ?? reactLocalStorage.get('token');
  http.post(`/configure/save`, { token: myToken, payload });
};
